import { DataSourceOptions } from 'typeorm'
import { RouterData } from '../entity/router/RouterData'
import { RouterDetails } from '../entity/router/RouterDetails'
import { ActionLog } from '../entity/shared/ActionLog'
import { ActionNotification } from '../entity/shared/ActionNotification'
import { Client } from '../entity/shared/Client'
import { CommsPlan } from '../entity/shared/CommsPlan'
import { ContractTariff } from '../entity/shared/ContractTariff'
import { ContractTariffLiveData } from '../entity/shared/ContractTariffLiveData'
import { DeviceType } from '../entity/shared/DeviceType'
import { HistoricalTariffUsageDaily } from '../entity/shared/HistoricalTariffUsageDaily'
import { HistoricalTariffUsageMonthly } from '../entity/shared/HistoricalTariffUsageMonthly'
import { HistoricalTariffUsageMonthlyFromSnapshot } from '../entity/shared/HistoricalTariffUsageMonthlyFromSnapshot'
import { IPRange } from '../entity/shared/IPRange'
import { NetworkExclusionMap } from '../entity/shared/NetworkExclusionMap'
import { OnBoarding } from '../entity/shared/Onboarding'
import { PasswordResetTokens } from '../entity/shared/PasswordResetTokens'
import { PvpcMap } from '../entity/shared/PvpcMap'
import { Role } from '../entity/shared/Roles'
import { RouterFeatureAvailability } from '../entity/shared/RouterFeatureAvailability'
import { Rule } from '../entity/shared/Rule.entity'
import { RuleHistory } from '../entity/shared/RuleHistory'
import { Tariff } from '../entity/shared/Tariff.entity'
import { User } from '../entity/shared/User'
import { VpnMap } from '../entity/shared/VpnMap'
import { Apns } from '../entity/usage/Apns'
import { NetworkHistory } from '../entity/usage/NetworkHistory'
import { NetworkHistoryPG } from '../entity/usage/NetworkHistoryPG'
import { RemoteSocket } from '../entity/usage/RemoteSocket'
import { Tele2Details } from '../entity/usage/Tele2Details'
import { Tele2PGUsage } from '../entity/usage/Tele2PGUsage'
import { Tele2Usage } from '../entity/usage/Tele2Usage'
import { Tele2UsageDaily } from '../entity/usage/Tele2UsageDaily'
import { VoiceSimsDetails } from '../entity/usage/VoiceSimsDetails'
import { WirelessLogicDetails } from '../entity/usage/WirelessLogicDetails'
import { WirelessLogicUsage } from '../entity/usage/WirelessLogicUsage'
import { WirelessLogicUsageDaily } from '../entity/usage/WirelessLogicUsageDaily'
import { CachedLookupLocation } from '../entity/cached-locations/CachedLocationLookup'
import { Product } from '../entity/shared/Products'
import { MavReading } from '../entity/kami/MavReading'
import { OrderItem } from '../entity/shared/OrderItem'
import { Order } from '../entity/shared/Order'
import { XeroAddress } from '../entity/shared/XeroAddress'
import { AssociatedProduct } from '../entity/shared/AssociatedProduct'
import { ProductPriceOverride } from '../entity/shared/ProductPriceOverride'
import { KamiClient } from '../entity/shared/KamiClient'
import { KamiTarget } from '../entity/shared/KamiTarget'
import { KamiPortRange } from '../entity/shared/KamiPortRange'
import { CustomAddress } from '../entity/shared/CustomAddress'
import { NetworkInclusionMap } from '../entity/shared/NetworkInclusionMap'
import { OverageMonitor } from '../entity/shared/OverageMonitor'

let processDefined = typeof(process) != 'undefined'

if(processDefined) {
  //console.log(`DB settings, ${process.env.USAGE_DB_HOST}, ${process.env.USAGE_DB_PORT}`)
}

export const go2sim_usage_db_connection:DataSourceOptions = {
  name:"go2sim_usage_db_1",
  type: "mysql",
  host: processDefined ? process.env.USAGE_DB_HOST : '',
  port: processDefined ? parseInt(process.env.USAGE_DB_PORT || '') : 0,
  username: processDefined ? process.env.USAGE_DB_USER : '',
  password: processDefined ? process.env.USAGE_DB_PASSWORD : '',
  database: processDefined ? process.env.USAGE_DB : '',
  entities: [
    Apns,
    NetworkHistory,
    NetworkHistoryPG,
    RemoteSocket,
    Tele2Details,
    Tele2PGUsage,
    Tele2Usage,
    Tele2UsageDaily,
    VoiceSimsDetails,
    WirelessLogicDetails,
    WirelessLogicUsage,
    WirelessLogicUsageDaily
  ],
  synchronize: false, // Don't turn this on. Dangerous.
  logging: false,
  timezone: "Z"
}

export const go2sim_shared_db_connection:DataSourceOptions = {
  name:"backoffice_shared",
  type: "mysql",
  host: processDefined ? process.env.SHARED_DB_HOST : '',
  port: processDefined ? parseInt(process.env.SHARED_DB_PORT || '') : 0,
  username: processDefined ? process.env.SHARED_DB_USER : '',
  password: processDefined ? process.env.SHARED_DB_PASSWORD : '',
  database: processDefined ? process.env.SHARED_DB : '',
  entities: [
    ActionLog,
    ActionNotification,
    Client,
    CommsPlan,
    ContractTariff,
    ContractTariffLiveData,
    DeviceType,
    HistoricalTariffUsageDaily,
    HistoricalTariffUsageMonthly,
    HistoricalTariffUsageMonthlyFromSnapshot,
    IPRange,
    NetworkExclusionMap,
    NetworkInclusionMap,
    OnBoarding,
    PasswordResetTokens,
    PvpcMap,
    Role,
    RouterFeatureAvailability,
    Rule,
    RuleHistory,
    Tariff,
    User,
    VpnMap,
    Product,
    Order,
    OrderItem,
    XeroAddress,
    AssociatedProduct,
    ProductPriceOverride,
    KamiClient,
    KamiTarget,
    KamiPortRange,
    CustomAddress,
    OverageMonitor
  ],
  synchronize: false, // Don't turn this on. Dangerous.
  logging: false,
  timezone: "Z"
}

export const go2sim_router_db_connection:DataSourceOptions = {
  name:"go2sim_router_db",
  type: "mysql",
  host: processDefined ? process.env.ROUTER_DB_HOST : '',
  port: processDefined ? parseInt(process.env.ROUTER_DB_PORT || '') : 0,
  username: processDefined ? process.env.ROUTER_DB_USER : '',
  password: processDefined ? process.env.ROUTER_DB_PASSWORD : '',
  database: processDefined ? process.env.ROUTER_DB : '',
  entities: [
    RouterData,
    RouterDetails
  ],
  synchronize: false, // Don't turn this on. Dangerous.
  logging: false,
  timezone: "Z"
}

export const go2sim_cached_location_db_connection:DataSourceOptions = {
  name:"go2sim_cached_location_db",
  type: "mysql",
  host: processDefined ? process.env.LOCATION_DB_HOST : '',
  port: processDefined ? parseInt(process.env.LOCATION_DB_PORT || '') : 0,
  username: processDefined ? process.env.LOCATION_DB_USER : '',
  password: processDefined ? process.env.LOCATION_DB_PASSWORD : '',
  database: processDefined ? process.env.LOCATION_DB : '',
  entities: [
    CachedLookupLocation
  ],
  synchronize: false, // Don't turn this on. Dangerous.
  logging: false,
  timezone: "Z"
}

export const go2sim_kami_db_connection:DataSourceOptions = {
  name:"go2sim_cached_location_db",
  type: "mysql",
  host: processDefined ? process.env.KAMI_DB_HOST : '',
  port: processDefined ? parseInt(process.env.KAMI_DB_PORT || '') : 0,
  username: processDefined ? process.env.KAMI_DB_USER : '',
  password: processDefined ? process.env.KAMI_DB_PASSWORD : '',
  database: processDefined ? process.env.KAMI_DB : '',
  entities: [
    MavReading
  ],
  synchronize: false, // Don't turn this on. Dangerous.
  logging: false,
  timezone: "Z"
}